import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import aa87823d0d9568a2c33fcb216ce700b86b from "./generated-c1fdb434-0350-4387-bdef-4366a4340cad.json";

import a919fecbe191da3e8e7a136dd55e03de0b from "./generated-64ee76c7-a0c5-4149-8ecd-9ad13fb61e68.json";

import abfd48d74963bb00717cf419103af9478b from "./generated-6ca06799-40a6-4b46-a375-a92c807b4b5b.json";

import a69c66ccb319f6eb45fd89a188fba99c1b from "./generated-e0530f0a-c2fb-4365-ab52-daaaf06d85d2.json";

import a3b99db1ff103b5e41170594e66171e4cb from "./generated-68b1976f-8669-4aed-82f6-1979999de3eb.json";

import a89abcbde6d77eaafbba6a499f74da60ab from "./generated-c9f4b361-4da3-44df-9cf6-395c78a57eac.json";

import ad5ad27d10be2f054c205f1ef1b34c2d9b from "./generated-3ff51089-0d8a-4690-95d7-22ead450f9b9.json";

import a0d3326502b8d3a7b66ce34095f2c8bffb from "./generated-e38fea58-c72c-4d28-9a24-4dfde35dcb59.json";

import afb0bc59715091cc4d05ea4f66de6d7e2b from "./generated-884515c0-5159-4e2f-9038-e495d24cee90.json";

import a1b864d4bc02d3b67e9502d09e952ce3db from "./generated-c579a8ca-63a8-41e9-9954-7296c4c639d2.json";

import afd163759e784be4175e5fd9200501de0b from "./generated-b6b23921-e499-4e78-b03f-82029c16ec87.json";

import acbccecdcb0007d8a6d47c4cb185869b2b from "./generated-e30e4024-ae04-4968-aa10-4357ddc040d2.json";

import ad40ca15df0aac51f6f387e4615fdfc42b from "./generated-1bfe1b03-a414-4ccf-856e-22f6c7c5f401.json";

import a7628eea8303c376de1e7e1b163cd7f98b from "./generated-2dda4a65-3db4-476d-8f19-657873d7a6a4.json";

import a1e9a814b1f54dc4dd8d6ff0dabce5f84b from "./generated-c09d9f6f-72a9-4d3c-b537-e96c4b3bf391.json";

import a2dbd1808b1e8a79f2c26f86062fad9b7b from "./generated-0106b2d3-6007-44d2-8977-6a994b862776.json";

import a0d0155875c65a13a4e38aabd089be203b from "./generated-39a967e3-9caa-46e4-8b15-6468577cce98.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(aa87823d0d9568a2c33fcb216ce700b86b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a919fecbe191da3e8e7a136dd55e03de0b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(abfd48d74963bb00717cf419103af9478b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a69c66ccb319f6eb45fd89a188fba99c1b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a3b99db1ff103b5e41170594e66171e4cb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a89abcbde6d77eaafbba6a499f74da60ab);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ad5ad27d10be2f054c205f1ef1b34c2d9b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a0d3326502b8d3a7b66ce34095f2c8bffb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(afb0bc59715091cc4d05ea4f66de6d7e2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a1b864d4bc02d3b67e9502d09e952ce3db);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(afd163759e784be4175e5fd9200501de0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(acbccecdcb0007d8a6d47c4cb185869b2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(afb0bc59715091cc4d05ea4f66de6d7e2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(ad40ca15df0aac51f6f387e4615fdfc42b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a7628eea8303c376de1e7e1b163cd7f98b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(afb0bc59715091cc4d05ea4f66de6d7e2b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a1e9a814b1f54dc4dd8d6ff0dabce5f84b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a2dbd1808b1e8a79f2c26f86062fad9b7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a0d0155875c65a13a4e38aabd089be203b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a1e9a814b1f54dc4dd8d6ff0dabce5f84b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */